const AnnotationColorHelper = ({ type_label, resolved }, type = null) => {
  if ((type_label == "CSR Note" || type == "CSR Note") && !resolved) {
    return 'amber lighten-1'
  } else if (resolved) {
    return 'green accent-4'
  } else {
    return 'pink accent-2'
  }
}

export default AnnotationColorHelper
